module.exports = __webpack_public_path__ + "static/media/logo-red-transparent.20aa86d1.png";